import { Injectable, Inject } from '@angular/core';
import { Observable, of } from 'rxjs';
import { IIdentificationTypeApiService } from './identification-type-api.interface';
import { ILogger } from '../logger';

@Injectable()
export class IdentificationTypeApiService implements IIdentificationTypeApiService {
  data: string[];

  constructor(@Inject('LoggerInjected') private logger: ILogger) {
    this.data = ['Driver License', 'State Identification', 'Passport'];
  }

  list(): Observable<string[]> {
    this.logger.debug('IdentificationTypeApiMockService.List', this.data);
    return of(this.data);
  }
}
